"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_TYPES = exports.QTYPES_CATEGORY = exports.PRICE_PROCESS_TYPES = exports.PriceType = exports.PanelType = exports.HealthProblemContext = exports.HealthProblemType = exports.RESPONDENT_QUALITY_SCORES = exports.QUICKTAG_STATUS = exports.QUICKTAG_STATUS_TYPES = exports.QUICKTAG_STATUS_NUMBER = exports.PROJECT_STATUS = exports.GROUP_TYPE_LOOKUP = exports.GROUP_TYPE = exports.QUOTA_STATUS_LOOKUP = exports.VALIDATION_OPTIONS = exports.BOT_SPEED = exports.OPTION_TYPE = exports.OPTION_TYPES = exports.OPTION_SELECTION_TYPES = exports.ANSWER_REFERENCE_TYPES = exports.MULTIMEDIA_TYPES = exports.BOT_CONNECTION_MODE = exports.SESSION_TYPES = exports.GUIDED_FANTASY_KEY = exports.TARGET_ACTIONS = exports.RESEARCH_CATEGORY = exports.ProbeLegacyDemerit = exports.ACTION_TYPES = exports.STAGE_TYPES = exports.STROKE_TYPES = exports.UserMessageByQTypes = exports.FRIENDLY_QUOTA_STATUS = exports.QUOTA_STATUS = exports.BOT_TERMINATE_TYPES = exports.EDITABLE_UMTYPES = exports.TENANT_LEVEL = exports.CONDITION_TYPES = exports.INVALID_ACCESS_TYPES = exports.SOCKET_EVENTS = exports.CONN_STATUS = exports.BOT_MODES = exports.TTYPES = exports.UMTYPES = exports.BMTYPES = exports.FETYPES = exports.ATYPES = exports.SPECIAL_QIDS = exports.QTYPES = exports.SERVER_TYPES = void 0;
exports.TRADE_OFF_TYPES = exports.NPS_CATEGORY = exports.CALLBACK_POINTER_KEYS = exports.IMAGE_OPTION_SIZING = exports.PROJECT_EDIT_STATUS = exports.OPTION_SIZE = exports.DISCOURSE_PERSONAS = exports.WEB_SOCKET_CONNECTION_TYPES = exports.API_VALIDATION_TYPES = exports.SecurityMode = exports.QUICKTAG_TYPES = exports.QuickTagMimeTypeFileTypeMap = exports.QuickTagMimeType = exports.QuickTagImportFileType = exports.SystemErrorCode = exports.MULTIPLE_ANSWER_AUDIENCE_RULE_MODE = exports.MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES = exports.SCREENER_TYPES = exports.VIEW_MODE = void 0;
var SERVER_TYPES;
(function (SERVER_TYPES) {
    SERVER_TYPES["AUTH_SERVER"] = "auth-server";
    SERVER_TYPES["PORTAL_SERVER"] = "portal-server";
    SERVER_TYPES["BOT_SERVER"] = "bot-server";
    SERVER_TYPES["DATA_API"] = "data-api";
})(SERVER_TYPES = exports.SERVER_TYPES || (exports.SERVER_TYPES = {}));
/*
 * TYPE ENUMS
 */
var QTYPES;
(function (QTYPES) {
    QTYPES["OPEN"] = "open";
    QTYPES["PII"] = "pii";
    QTYPES["MULTIPLE_CHOICE"] = "multiple_choice";
    QTYPES["SINGLE_CHOICE"] = "single_choice";
    QTYPES["RANK_ORDER"] = "rank_order";
    QTYPES["SCALE"] = "scale";
    QTYPES["SLIDER"] = "slider";
    QTYPES["NUMERIC"] = "numeric";
    QTYPES["POPUP"] = "popup";
    QTYPES["POPUP_CARD"] = "popup_card";
    QTYPES["MULTI_POPUP_CARD"] = "multi_popup_card";
    QTYPES["TRADE_OFF"] = "trade_off";
    QTYPES["MULTIMEDIA"] = "multimedia";
    QTYPES["TEXT_MESSAGE"] = "text_message";
    QTYPES["RATE_IMAGE"] = "rate_image";
    QTYPES["HOTSPOT"] = "hotspot";
    QTYPES["NPS"] = "nps";
    QTYPES["VIDEO_ANNOTATION"] = "video_annotation";
    QTYPES["VIDEO_ANNOTATION_DEPRECATED"] = "annotate";
    QTYPES["YOUTUBE"] = "youtube";
    QTYPES["DROPDOWN"] = "dropdown";
    QTYPES["ICONS"] = "icons";
    QTYPES["AGE"] = "age";
    QTYPES["MAP"] = "map";
    QTYPES["VECTOR_MAP"] = "vector_map";
    QTYPES["VIRTUAL"] = "virtual";
    QTYPES["TREEMAN"] = "treeman";
    QTYPES["SFA"] = "sfa";
    QTYPES["TEXT_HIGHLIGHTER"] = "text_highlighter";
    QTYPES["TEXT_HIGHLIGHTER_READONLY"] = "text_highlighter_readonly";
    QTYPES["GUIDED_FANTASY"] = "guided_fantasy";
    QTYPES["HOT_AIR_BALLOON"] = "hot_air_balloon";
    QTYPES["JOURNEY"] = "journey";
    QTYPES["JOURNEY_SELECT"] = "journey_select";
    QTYPES["RESUME"] = "resume";
    QTYPES["DEPARTING_MESSAGE"] = "departing_message";
    QTYPES["AD_BUILDER"] = "ad_builder";
    QTYPES["GROUP"] = "group";
    QTYPES["GREETING_TEXT"] = "greeting_text";
    QTYPES["REDIRECT"] = "redirect_text";
    QTYPES["RANDOMIZER"] = "randomizer";
    QTYPES["RAPID_CHOICE"] = "rapid_choice";
    QTYPES["MANAGEMENT_NUMBER"] = "management_number";
    QTYPES["MANAGEMENT_PIE"] = "management_pie";
    QTYPES["MANAGEMENT_STATUS"] = "management_status";
    QTYPES["MULTI_TARGETS"] = "multi_targets";
    // SYSTEM QUESTIONS
    QTYPES["URL_METADATA"] = "url_metadata";
    QTYPES["SYSTEM_METADATA"] = "system_metadata";
    QTYPES["LANGUAGE"] = "language";
    QTYPES["PANEL"] = "panel";
    QTYPES["DEVICE"] = "device";
    QTYPES["SPECIALS"] = "specials";
    QTYPES["ANALYSIS_VARIABLE_TYPE"] = "analysisVariables";
})(QTYPES = exports.QTYPES || (exports.QTYPES = {}));
var SPECIAL_QIDS;
(function (SPECIAL_QIDS) {
    SPECIAL_QIDS[SPECIAL_QIDS["LANGUAGE"] = -10] = "LANGUAGE";
    SPECIAL_QIDS[SPECIAL_QIDS["QUOTA"] = -2] = "QUOTA";
    SPECIAL_QIDS[SPECIAL_QIDS["RESUME"] = -3] = "RESUME";
    SPECIAL_QIDS[SPECIAL_QIDS["PANEL_SOURCE"] = -4] = "PANEL_SOURCE";
    SPECIAL_QIDS[SPECIAL_QIDS["QUOTA_GROUP"] = -5] = "QUOTA_GROUP";
    SPECIAL_QIDS[SPECIAL_QIDS["GREETING_TEXT"] = -6] = "GREETING_TEXT";
    SPECIAL_QIDS[SPECIAL_QIDS["REDIRECT_TEXT"] = -7] = "REDIRECT_TEXT";
    SPECIAL_QIDS[SPECIAL_QIDS["URL_METADATA"] = -8] = "URL_METADATA";
    SPECIAL_QIDS[SPECIAL_QIDS["DEVICE"] = -9] = "DEVICE";
})(SPECIAL_QIDS = exports.SPECIAL_QIDS || (exports.SPECIAL_QIDS = {}));
var ATYPES;
(function (ATYPES) {
    ATYPES["TEXT"] = "text";
    ATYPES["SINGLE_OPTION"] = "single_option";
    ATYPES["MULTIPLE_OPTIONS"] = "multiple_options";
    ATYPES["ACK"] = "ack";
    ATYPES["DEPARTING"] = "departing";
    ATYPES["POPUP"] = "popup";
    ATYPES["MAP"] = "map";
    ATYPES["VECTOR_MAP"] = "vector_map";
    ATYPES["RATED_RANGES"] = "rated_ranges";
    ATYPES["TRADE_OFF"] = "trade_off";
    ATYPES["NUMERIC"] = "numeric";
    ATYPES["ICONS"] = "icons_rating";
    ATYPES["JOURNEY"] = "journey";
    ATYPES["JOURNEY_SELECT"] = "journey_select";
    ATYPES["SKIP"] = "skip";
    ATYPES["RATE_IMAGE"] = "rate_image";
    ATYPES["VIDEO_ANNOTATION"] = "video_annotation";
    ATYPES["RESUME"] = "resume_select";
})(ATYPES = exports.ATYPES || (exports.ATYPES = {}));
var FETYPES;
(function (FETYPES) {
    FETYPES["QUESTION"] = "question";
    FETYPES["RANDOMIZED_GROUP"] = "randomized_group";
    FETYPES["COMPLETE"] = "complete";
})(FETYPES = exports.FETYPES || (exports.FETYPES = {}));
var BMTYPES;
(function (BMTYPES) {
    // QUESTIONS
    BMTYPES["QUESTION"] = "bot/question";
    BMTYPES["LANGUAGE_PROMPT"] = "bot/language_prompt";
    BMTYPES["RESUME_PROMPT"] = "bot/resume_prompt";
    BMTYPES["SWITCH_THEME"] = "bot/switch_theme";
    // MESSAGES
    BMTYPES["TEXT"] = "bot/text";
    BMTYPES["RICH_TEXT"] = "bot/rich_text";
    BMTYPES["TYPIST_TEXT"] = "bot/typist_text";
    BMTYPES["IMAGE"] = "bot/image";
    BMTYPES["VIDEO"] = "bot/video";
    BMTYPES["AUDIO"] = "bot/audio";
    BMTYPES["TYPING"] = "bot/typing";
    BMTYPES["PRELOADER"] = "bot/preloader";
    BMTYPES["RECONNECTION"] = "bot/reconnection";
    BMTYPES["SYSTEM"] = "bot/system";
    // ERRORS and SIGNALS
    BMTYPES["SIGNAL"] = "bot/signal";
    // @TODO: these could be incorporated into SignalMessage!
    BMTYPES["INVALID_INPUT"] = "bot/invalid_input";
    BMTYPES["TERMINATE"] = "bot/terminate";
    BMTYPES["QUOTA_FULL"] = "bot/quota_full";
})(BMTYPES = exports.BMTYPES || (exports.BMTYPES = {}));
var UMTYPES;
(function (UMTYPES) {
    // ANSWER RESPONSES
    UMTYPES["MULTI_SELECTION"] = "user/multi_selection";
    UMTYPES["SINGLE_SELECTION"] = "user/single_selection";
    UMTYPES["TEXT"] = "user/text";
    UMTYPES["POPUP"] = "user/popup";
    UMTYPES["MULTIPLE_POPUP"] = "mutiple_popup";
    UMTYPES["ACK"] = "user/ack";
    UMTYPES["DEPARTING"] = "user/departing";
    UMTYPES["RATE_IMAGE"] = "user/rated_image";
    UMTYPES["AD_BUILDER"] = "user/ad_builder";
    UMTYPES["SKIP"] = "user/skip";
    UMTYPES["ICONS_RATING"] = "user/icons_rating";
    UMTYPES["NUMERIC"] = "user/numeric";
    UMTYPES["JOURNEY"] = "user/journey";
    UMTYPES["JOURNEY_SELECT"] = "user/journey_select";
    UMTYPES["VECTOR_MAP"] = "user/vector_map";
    UMTYPES["MAP"] = "user/map";
    UMTYPES["TRADE_OFF"] = "user/trade_off";
    UMTYPES["VIDEO_ANNOTATION"] = "user/video_annotation";
    // SPECIAL
    UMTYPES["JUMP_REQUEST"] = "user/jump_request";
    UMTYPES["EDIT_REQUEST"] = "user/edit_request";
    UMTYPES["LANGUAGE_SELECTION"] = "user/language_selection";
    UMTYPES["RESUME_SELECTION"] = "user/resume_selection";
    UMTYPES["READY_SIGNAL"] = "user/ready_signal";
})(UMTYPES = exports.UMTYPES || (exports.UMTYPES = {}));
var TTYPES;
(function (TTYPES) {
    TTYPES["QUESTION"] = "task/question";
    TTYPES["MESSAGE"] = "task/message";
})(TTYPES = exports.TTYPES || (exports.TTYPES = {}));
var BOT_MODES;
(function (BOT_MODES) {
    BOT_MODES["CHAT"] = "bot/session/chat";
    BOT_MODES["TESTBED"] = "bot/session/testbed";
    BOT_MODES["MONITOR"] = "bot/session/monitor";
})(BOT_MODES = exports.BOT_MODES || (exports.BOT_MODES = {}));
var CONN_STATUS;
(function (CONN_STATUS) {
    CONN_STATUS["CONNECTING"] = "connecting";
    CONN_STATUS["CONNECTED"] = "connected";
    CONN_STATUS["RECONNECTING"] = "reconnecting";
    CONN_STATUS["ID_NOT_FOUND"] = "id_not_found";
    CONN_STATUS["BLOCK_MULTI_ACCESS"] = "block-multiple-access";
    CONN_STATUS["SURVEY_CLOSE"] = "survey-close";
    CONN_STATUS["INVALID_BROWSER"] = "invalid-browser";
    CONN_STATUS["CONNECTION_FAILED"] = "connection-failed";
    CONN_STATUS["QUOTA_OVERFLOW"] = "quota-overflow";
})(CONN_STATUS = exports.CONN_STATUS || (exports.CONN_STATUS = {}));
var SOCKET_EVENTS;
(function (SOCKET_EVENTS) {
    SOCKET_EVENTS["CONNECT"] = "connect";
    SOCKET_EVENTS["INIT"] = "init";
    SOCKET_EVENTS["TESTBED"] = "testbed";
    SOCKET_EVENTS["MONITOR"] = "monitor";
    SOCKET_EVENTS["USER_MESSAGE"] = "user-message";
    SOCKET_EVENTS["EDIT_MESSAGE"] = "edit-message";
    SOCKET_EVENTS["BOT_MESSAGE"] = "bot-message";
    SOCKET_EVENTS["INIT_CHAT_REPLY"] = "initChatReply";
    SOCKET_EVENTS["SYNC"] = "sync";
    SOCKET_EVENTS["CONNECTION_CHECK"] = "connection-check";
    SOCKET_EVENTS["DISCONNECT"] = "disconnect";
    SOCKET_EVENTS["INVALID"] = "INVALID";
})(SOCKET_EVENTS = exports.SOCKET_EVENTS || (exports.SOCKET_EVENTS = {}));
var INVALID_ACCESS_TYPES;
(function (INVALID_ACCESS_TYPES) {
    INVALID_ACCESS_TYPES["MULTIPLE_ACCESS"] = "MULTIPLE_ACCESS";
    INVALID_ACCESS_TYPES["ID_NOT_FOUND"] = "ID_NOT_FOUND";
    INVALID_ACCESS_TYPES["FLOW_NOT_VALID"] = "FLOW_NOT_VALID";
    INVALID_ACCESS_TYPES["SURVEY_CLOSE"] = "SURVEY_CLOSE";
    INVALID_ACCESS_TYPES["QUOTA_OVERFLOW"] = "QUOTA_OVERFLOW";
})(INVALID_ACCESS_TYPES = exports.INVALID_ACCESS_TYPES || (exports.INVALID_ACCESS_TYPES = {}));
/** NOTE: May be duplicate of COMPARE_TYPE */
var CONDITION_TYPES;
(function (CONDITION_TYPES) {
    CONDITION_TYPES["REFERENCE_OPTION"] = "REFERENCE_OPTION";
    CONDITION_TYPES["REFERENCE_TARGET"] = "REFERENCE_TARGET";
    // QUESTION_ANSWER = 'QUESTION_ANSWER',
    CONDITION_TYPES["CUSTOM_VALUE"] = "CUSTOM_VALUE";
    // NO_COMPARE = 'NO_COMPARE',
})(CONDITION_TYPES = exports.CONDITION_TYPES || (exports.CONDITION_TYPES = {}));
var TENANT_LEVEL;
(function (TENANT_LEVEL) {
    TENANT_LEVEL[TENANT_LEVEL["PENDING"] = -2] = "PENDING";
    TENANT_LEVEL[TENANT_LEVEL["GLOBAL"] = -1] = "GLOBAL";
    TENANT_LEVEL[TENANT_LEVEL["SANDBOX"] = 0] = "SANDBOX";
    TENANT_LEVEL[TENANT_LEVEL["FULL_SERVICE"] = 1] = "FULL_SERVICE";
    TENANT_LEVEL[TENANT_LEVEL["SELF_SERVICE"] = 2] = "SELF_SERVICE";
    TENANT_LEVEL[TENANT_LEVEL["INCA_WIZARD"] = 3] = "INCA_WIZARD";
})(TENANT_LEVEL = exports.TENANT_LEVEL || (exports.TENANT_LEVEL = {}));
/*
 * TYPE FILTERS
 * [subsets of type enums for specifying functionality]
 */
exports.EDITABLE_UMTYPES = [
    // only these UMTYPES allow user editing
    UMTYPES.MULTI_SELECTION,
    UMTYPES.SINGLE_SELECTION,
    UMTYPES.TEXT,
    UMTYPES.RATE_IMAGE,
    UMTYPES.AD_BUILDER,
    UMTYPES.ICONS_RATING,
    UMTYPES.NUMERIC,
    UMTYPES.POPUP,
    UMTYPES.MULTIPLE_POPUP,
    UMTYPES.MAP,
    UMTYPES.VECTOR_MAP,
    UMTYPES.VIDEO_ANNOTATION,
    UMTYPES.JOURNEY,
    UMTYPES.JOURNEY_SELECT
];
var BOT_TERMINATE_TYPES;
(function (BOT_TERMINATE_TYPES) {
    BOT_TERMINATE_TYPES["CTA"] = "cta";
    BOT_TERMINATE_TYPES["MSG"] = "msg";
    BOT_TERMINATE_TYPES["DISABLED"] = "DISABLED";
})(BOT_TERMINATE_TYPES = exports.BOT_TERMINATE_TYPES || (exports.BOT_TERMINATE_TYPES = {}));
/*
 * QUOTA TYPES
 */
var QUOTA_STATUS;
(function (QUOTA_STATUS) {
    QUOTA_STATUS[QUOTA_STATUS["COMPLETE"] = 1] = "COMPLETE";
    QUOTA_STATUS[QUOTA_STATUS["TERMINATE"] = 2] = "TERMINATE";
    QUOTA_STATUS[QUOTA_STATUS["QUOTA_FULL"] = 3] = "QUOTA_FULL";
    QUOTA_STATUS[QUOTA_STATUS["SECURITY"] = 4] = "SECURITY";
    QUOTA_STATUS[QUOTA_STATUS["DROPOUT"] = 5] = "DROPOUT";
    QUOTA_STATUS[QUOTA_STATUS["LIVE"] = 6] = "LIVE";
})(QUOTA_STATUS = exports.QUOTA_STATUS || (exports.QUOTA_STATUS = {}));
var FRIENDLY_QUOTA_STATUS;
(function (FRIENDLY_QUOTA_STATUS) {
    FRIENDLY_QUOTA_STATUS["COMPLETE"] = "Completes";
    FRIENDLY_QUOTA_STATUS["TERMINATE"] = "Termination";
    FRIENDLY_QUOTA_STATUS["QUOTA_FULL"] = "Quota Full";
    FRIENDLY_QUOTA_STATUS["SECURITY"] = "Disqualification";
    FRIENDLY_QUOTA_STATUS["DROPOUT"] = "Dropout";
    FRIENDLY_QUOTA_STATUS["LIVE"] = "Live";
})(FRIENDLY_QUOTA_STATUS = exports.FRIENDLY_QUOTA_STATUS || (exports.FRIENDLY_QUOTA_STATUS = {}));
/**
 * Maps each UserMessage type (UMTYPES) to a list of QTYPES for which it may correspond.
 */
exports.UserMessageByQTypes = (_a = {},
    _a[UMTYPES.ACK] = [QTYPES.MULTIMEDIA],
    _a[UMTYPES.AD_BUILDER] = [QTYPES.AD_BUILDER],
    _a[UMTYPES.DEPARTING] = [QTYPES.DEPARTING_MESSAGE],
    _a[UMTYPES.ICONS_RATING] = [QTYPES.ICONS],
    _a[UMTYPES.JOURNEY] = [QTYPES.JOURNEY],
    _a[UMTYPES.JOURNEY_SELECT] = [QTYPES.JOURNEY_SELECT],
    _a[UMTYPES.MULTIPLE_POPUP] = [QTYPES.MULTI_POPUP_CARD],
    _a[UMTYPES.MULTI_SELECTION] = [
        QTYPES.MULTIPLE_CHOICE,
        QTYPES.RANK_ORDER,
        QTYPES.HOTSPOT,
        QTYPES.VIRTUAL,
        QTYPES.RAPID_CHOICE,
        QTYPES.TEXT_HIGHLIGHTER,
        QTYPES.TEXT_HIGHLIGHTER_READONLY
    ],
    _a[UMTYPES.POPUP] = [QTYPES.POPUP_CARD],
    _a[UMTYPES.SINGLE_SELECTION] = [
        QTYPES.TREEMAN,
        QTYPES.SINGLE_CHOICE,
        QTYPES.SCALE,
        QTYPES.NPS
    ],
    _a[UMTYPES.TEXT] = [QTYPES.OPEN, QTYPES.PII],
    _a[UMTYPES.TRADE_OFF] = [QTYPES.TRADE_OFF],
    _a[UMTYPES.VECTOR_MAP] = [QTYPES.VECTOR_MAP],
    _a[UMTYPES.VIDEO_ANNOTATION] = [QTYPES.VIDEO_ANNOTATION],
    _a[UMTYPES.LANGUAGE_SELECTION] = [QTYPES.LANGUAGE],
    _a[UMTYPES.RESUME_SELECTION] = [QTYPES.RESUME],
    _a);
var STROKE_TYPES;
(function (STROKE_TYPES) {
    STROKE_TYPES["LIKE"] = "like";
    STROKE_TYPES["DISLIKE"] = "dislike";
    STROKE_TYPES["CONFUSED"] = "confused";
    STROKE_TYPES["NEUTRAL"] = "neutral";
})(STROKE_TYPES = exports.STROKE_TYPES || (exports.STROKE_TYPES = {}));
var STAGE_TYPES;
(function (STAGE_TYPES) {
    STAGE_TYPES["FIRST"] = "FIRST_STAGE";
    STAGE_TYPES["SECOND"] = "SECOND_STAGE";
})(STAGE_TYPES = exports.STAGE_TYPES || (exports.STAGE_TYPES = {}));
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["FAVOURITE"] = "Favourite";
    ACTION_TYPES["LIKE"] = "Like";
    ACTION_TYPES["DISLIKE"] = "Dislike";
    ACTION_TYPES["NOT_SURE"] = "Not sure";
})(ACTION_TYPES = exports.ACTION_TYPES || (exports.ACTION_TYPES = {}));
var ProbeLegacyDemerit;
(function (ProbeLegacyDemerit) {
    ProbeLegacyDemerit["UNINFORMATIVE"] = "LAZY_DISQUALIFY";
    ProbeLegacyDemerit["GIBBERISH"] = "GIBBERISH_DISQUALIFY";
    ProbeLegacyDemerit["NO_DEMERIT"] = "";
})(ProbeLegacyDemerit = exports.ProbeLegacyDemerit || (exports.ProbeLegacyDemerit = {}));
var RESEARCH_CATEGORY;
(function (RESEARCH_CATEGORY) {
    RESEARCH_CATEGORY["UA"] = "UA";
    RESEARCH_CATEGORY["AD"] = "AD";
    RESEARCH_CATEGORY["CONCEPT"] = "CONCEPT";
    RESEARCH_CATEGORY["CX"] = "CX";
    RESEARCH_CATEGORY["BRAND"] = "BRAND";
})(RESEARCH_CATEGORY = exports.RESEARCH_CATEGORY || (exports.RESEARCH_CATEGORY = {}));
var TARGET_ACTIONS;
(function (TARGET_ACTIONS) {
    TARGET_ACTIONS["AVOID"] = "AVOID";
    TARGET_ACTIONS["TRIGGER_ON_DETECTION"] = "PROBE_ON_DETECTION";
    TARGET_ACTIONS["TRIGGER_ON_ABSENCE"] = "PROBE_ON_ABSENCE";
    TARGET_ACTIONS["NONE"] = "NONE";
    TARGET_ACTIONS["TRIGGER_ALWAYS"] = "TRIGGER_ALWAYS";
    TARGET_ACTIONS["TERMINATE_ON_DETECTION"] = "TERMINATE_ON_DETECTION";
})(TARGET_ACTIONS = exports.TARGET_ACTIONS || (exports.TARGET_ACTIONS = {}));
var GUIDED_FANTASY_KEY;
(function (GUIDED_FANTASY_KEY) {
    GUIDED_FANTASY_KEY["FIRST_STAGE_MESSAGE"] = "firstQ_message";
    GUIDED_FANTASY_KEY["FIRST_STAGE_QUESTION"] = "firstQ";
    GUIDED_FANTASY_KEY["SECOND_STAGE_MESSAGE"] = "secondQ_message";
    GUIDED_FANTASY_KEY["SECOND_STAGE_QUESTION"] = "secondQ";
    GUIDED_FANTASY_KEY["THIRD_STAGE_MESSAGE"] = "thirdQ_message";
    GUIDED_FANTASY_KEY["THIRD_STAGE_QUESTION"] = "thirdQ";
})(GUIDED_FANTASY_KEY = exports.GUIDED_FANTASY_KEY || (exports.GUIDED_FANTASY_KEY = {}));
var SESSION_TYPES;
(function (SESSION_TYPES) {
    SESSION_TYPES["USER"] = "user";
    SESSION_TYPES["TESTBED"] = "testbed";
    SESSION_TYPES["MONITOR"] = "monitor";
})(SESSION_TYPES = exports.SESSION_TYPES || (exports.SESSION_TYPES = {}));
var BOT_CONNECTION_MODE;
(function (BOT_CONNECTION_MODE) {
    BOT_CONNECTION_MODE["NEW_PAGE"] = "NEW_PAGE";
    BOT_CONNECTION_MODE["ON_RESUME"] = "ON_RESUME";
    BOT_CONNECTION_MODE["ON_LANGUAGE"] = "ON_LANGUAGE";
    BOT_CONNECTION_MODE["SOCKET_RECONNECT"] = "SOCKET_RECONNECT";
    BOT_CONNECTION_MODE["ON_QUESTION"] = "ON_QUESTION";
})(BOT_CONNECTION_MODE = exports.BOT_CONNECTION_MODE || (exports.BOT_CONNECTION_MODE = {}));
var MULTIMEDIA_TYPES;
(function (MULTIMEDIA_TYPES) {
    MULTIMEDIA_TYPES["RICH_TEXT"] = "richText";
    MULTIMEDIA_TYPES["TEXT"] = "plainText";
    MULTIMEDIA_TYPES["IMAGE"] = "image";
    MULTIMEDIA_TYPES["VIDEO"] = "video";
    MULTIMEDIA_TYPES["AUDIO"] = "audio";
})(MULTIMEDIA_TYPES = exports.MULTIMEDIA_TYPES || (exports.MULTIMEDIA_TYPES = {}));
var ANSWER_REFERENCE_TYPES;
(function (ANSWER_REFERENCE_TYPES) {
    ANSWER_REFERENCE_TYPES["QUESTION"] = "QUESTION";
    ANSWER_REFERENCE_TYPES["URL_METADATA"] = "URL_METADATA";
})(ANSWER_REFERENCE_TYPES = exports.ANSWER_REFERENCE_TYPES || (exports.ANSWER_REFERENCE_TYPES = {}));
var OPTION_SELECTION_TYPES;
(function (OPTION_SELECTION_TYPES) {
    OPTION_SELECTION_TYPES[OPTION_SELECTION_TYPES["SELECTED"] = 1] = "SELECTED";
    OPTION_SELECTION_TYPES[OPTION_SELECTION_TYPES["UNSELECTED"] = 0] = "UNSELECTED";
    OPTION_SELECTION_TYPES[OPTION_SELECTION_TYPES["NOT_SHOWN"] = -1] = "NOT_SHOWN";
})(OPTION_SELECTION_TYPES = exports.OPTION_SELECTION_TYPES || (exports.OPTION_SELECTION_TYPES = {}));
var OPTION_TYPES;
(function (OPTION_TYPES) {
    OPTION_TYPES["IMAGE_AND_TEXT"] = "imageAndText";
    OPTION_TYPES["IMAGE_ONLY"] = "imageOnly";
    OPTION_TYPES["TEXT_ONLY"] = "textOnly";
    OPTION_TYPES["HIGHLIGHT"] = "highlight";
    OPTION_TYPES["CONDITION"] = "condition";
})(OPTION_TYPES = exports.OPTION_TYPES || (exports.OPTION_TYPES = {}));
exports.OPTION_TYPE = [
    'imageOnly',
    'textOnly',
    'imageAndText',
    'highlight'
];
exports.BOT_SPEED = [
    { value: 'normal', label: 'Normal' },
    { value: 'slow', label: 'Slow' },
    { value: 'fast', label: 'Fast' },
    { value: 'fastest', label: 'Fastest' }
];
exports.VALIDATION_OPTIONS = [
    { value: 0, label: 'Postal / Zip code(CA)' },
    { value: 1, label: 'Email' },
    { value: 2, label: 'Phone number' }
];
exports.QUOTA_STATUS_LOOKUP = reverseLookup(QUOTA_STATUS);
// Group types
exports.GROUP_TYPE = {
    sequential: 0,
    randomized: 1,
    picksomefromgroup: 2
};
exports.GROUP_TYPE_LOOKUP = reverseLookup(exports.GROUP_TYPE);
// some helper functions
function reverseLookup(dict) {
    var result = {};
    for (var k in dict) {
        result[dict[k]] = k;
    }
    return result;
}
var PROJECT_STATUS;
(function (PROJECT_STATUS) {
    PROJECT_STATUS["ARCHIVED"] = "ARCHIVED";
    PROJECT_STATUS["DRAFT"] = "DRAFT";
    PROJECT_STATUS["LIVE"] = "LIVE";
    PROJECT_STATUS["PAUSED"] = "PAUSED";
    PROJECT_STATUS["COMPLETE"] = "COMPLETE";
    PROJECT_STATUS["REVIEW"] = "REVIEW";
})(PROJECT_STATUS = exports.PROJECT_STATUS || (exports.PROJECT_STATUS = {}));
var QUICKTAG_STATUS_NUMBER;
(function (QUICKTAG_STATUS_NUMBER) {
    QUICKTAG_STATUS_NUMBER["ANALYZING"] = "0";
    QUICKTAG_STATUS_NUMBER["READY"] = "2";
})(QUICKTAG_STATUS_NUMBER = exports.QUICKTAG_STATUS_NUMBER || (exports.QUICKTAG_STATUS_NUMBER = {}));
exports.QUICKTAG_STATUS_TYPES = (_b = {},
    _b[QUICKTAG_STATUS_NUMBER.ANALYZING] = 'ANALYZING',
    _b[QUICKTAG_STATUS_NUMBER.READY] = 'READY',
    _b);
var QUICKTAG_STATUS;
(function (QUICKTAG_STATUS) {
    QUICKTAG_STATUS["ANALYZING"] = "ANALYZING";
    QUICKTAG_STATUS["READY"] = "READY";
})(QUICKTAG_STATUS = exports.QUICKTAG_STATUS || (exports.QUICKTAG_STATUS = {}));
var RESPONDENT_QUALITY_SCORES;
(function (RESPONDENT_QUALITY_SCORES) {
    RESPONDENT_QUALITY_SCORES["GOOD"] = "Good Quality";
    RESPONDENT_QUALITY_SCORES["FLAGGED"] = "Flagged";
    RESPONDENT_QUALITY_SCORES["DISQUALIFIED"] = "Disqualified";
})(RESPONDENT_QUALITY_SCORES = exports.RESPONDENT_QUALITY_SCORES || (exports.RESPONDENT_QUALITY_SCORES = {}));
(function (CONDITION_TYPES) {
    CONDITION_TYPES["PRECONDITION"] = "precondition";
    CONDITION_TYPES["POSTCONDITION"] = "postcondition";
})(CONDITION_TYPES = exports.CONDITION_TYPES || (exports.CONDITION_TYPES = {}));
var HealthProblemType;
(function (HealthProblemType) {
    HealthProblemType["ERROR"] = "ERROR";
    HealthProblemType["WARNING"] = "WARNING";
    HealthProblemType["DRAFT"] = "DRAFT";
    HealthProblemType["SUCCESS"] = "SUCCESS";
})(HealthProblemType = exports.HealthProblemType || (exports.HealthProblemType = {}));
var HealthProblemContext;
(function (HealthProblemContext) {
    HealthProblemContext["QUESTION"] = "QUESTION";
    HealthProblemContext["AUDIENCE"] = "AUDIENCE";
    HealthProblemContext["CONDITION"] = "CONDITION";
    HealthProblemContext["OVERVIEW"] = "OVERVIEW";
    HealthProblemContext["PREVIEW"] = "PREVIEW";
})(HealthProblemContext = exports.HealthProblemContext || (exports.HealthProblemContext = {}));
var PanelType;
(function (PanelType) {
    PanelType["INCA"] = "inca";
    PanelType["SELF_PROVIDED"] = "self_provided";
})(PanelType = exports.PanelType || (exports.PanelType = {}));
var PriceType;
(function (PriceType) {
    PriceType["REGULAR"] = "REGULAR";
    PriceType["FREE"] = "FREE";
    PriceType["CUSTOM"] = "CUSTOM";
    PriceType["REQUEST_QUOTE"] = "REQUEST_QUOTE";
    PriceType["INCIDENCE"] = "INCIDENCE";
    PriceType["NOT_FEASIBLE"] = "NOT_FEASIBLE";
})(PriceType = exports.PriceType || (exports.PriceType = {}));
var PRICE_PROCESS_TYPES;
(function (PRICE_PROCESS_TYPES) {
    PRICE_PROCESS_TYPES["READY"] = "READY";
    PRICE_PROCESS_TYPES["PROCESSING"] = "PROCESSING";
    PRICE_PROCESS_TYPES["COMPLETE"] = "COMPLETE";
})(PRICE_PROCESS_TYPES = exports.PRICE_PROCESS_TYPES || (exports.PRICE_PROCESS_TYPES = {}));
var QTYPES_CATEGORY;
(function (QTYPES_CATEGORY) {
    QTYPES_CATEGORY["STANDARD"] = "Standard Questions";
    QTYPES_CATEGORY["SPECIALS"] = "Specialty Questions";
    QTYPES_CATEGORY["STATIC_CONTENT"] = "Static Content";
    QTYPES_CATEGORY["LOGICAL"] = "Logic Questions";
    QTYPES_CATEGORY["BUILT_IN"] = "Built-In Questions";
})(QTYPES_CATEGORY = exports.QTYPES_CATEGORY || (exports.QTYPES_CATEGORY = {}));
var QUERY_TYPES;
(function (QUERY_TYPES) {
    QUERY_TYPES["MODE"] = "mode";
})(QUERY_TYPES = exports.QUERY_TYPES || (exports.QUERY_TYPES = {}));
var VIEW_MODE;
(function (VIEW_MODE) {
    VIEW_MODE["DEV"] = "dev";
})(VIEW_MODE = exports.VIEW_MODE || (exports.VIEW_MODE = {}));
var SCREENER_TYPES;
(function (SCREENER_TYPES) {
    SCREENER_TYPES["TERMINATE"] = "TERMINATE";
    SCREENER_TYPES["TERMINATE_QUOTA"] = "TERMINATE_QUOTA";
    SCREENER_TYPES["QUOTA"] = "QUOTA";
    SCREENER_TYPES["NORMAL"] = "NORMAL";
    // for custom mcq
    SCREENER_TYPES["MUST_SELECT_ALL"] = "MUST_SELECT_ALL";
    SCREENER_TYPES["MUST_SELECT_ANY"] = "MUST_SELECT_ANY";
    SCREENER_TYPES["MAY_SELECT"] = "MAY_SELECT";
})(SCREENER_TYPES = exports.SCREENER_TYPES || (exports.SCREENER_TYPES = {}));
var MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES;
(function (MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES) {
    MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES["MUST_SELECT"] = "MUST_SELECT";
    MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES["DISQUALIFY"] = "DISQUALIFY";
    MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES["MAY_SELECT"] = "MAY_SELECT";
})(MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES = exports.MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES || (exports.MULTIPLE_ANSWER_AUDIENCE_RULE_TYPES = {}));
var MULTIPLE_ANSWER_AUDIENCE_RULE_MODE;
(function (MULTIPLE_ANSWER_AUDIENCE_RULE_MODE) {
    MULTIPLE_ANSWER_AUDIENCE_RULE_MODE["ANY"] = "ANY";
    MULTIPLE_ANSWER_AUDIENCE_RULE_MODE["ALL"] = "ALL";
})(MULTIPLE_ANSWER_AUDIENCE_RULE_MODE = exports.MULTIPLE_ANSWER_AUDIENCE_RULE_MODE || (exports.MULTIPLE_ANSWER_AUDIENCE_RULE_MODE = {}));
var SystemErrorCode;
(function (SystemErrorCode) {
    SystemErrorCode["Critical"] = "CRITICAL";
    SystemErrorCode["SQLRequestTimeout"] = "SQL_REQUEST_TIMEOUT";
    SystemErrorCode["SQLQueryError"] = "SQL_QUERY_ERROR";
    SystemErrorCode["SQLConnectionError"] = "SQL_CONNECTION_ERROR";
    SystemErrorCode["ServerCrash"] = "SERVER_CRASH";
    SystemErrorCode["InvalidUserResponse"] = "INVALID_USER_RESPONSE";
    SystemErrorCode["RedisError"] = "REDIS_ERROR";
    SystemErrorCode["NLPJobsError"] = "NLP_JOBS_ERROR";
    SystemErrorCode["DataAPIPackageDataRetrievalError"] = "PACKAGE_RETRIEVAL_ERROR";
    SystemErrorCode["DataAPIPackageRefreshError"] = "PACKAGE_REFRESH_ERROR";
    SystemErrorCode["DynataError"] = "DYNATA_ERROR";
    SystemErrorCode["MongoConnectionError"] = "MONGO_CONNECTION_ERROR";
    SystemErrorCode["MongoInsertionError"] = "MONGO_INSERTION_ERROR";
    SystemErrorCode["MongoReadingError"] = "MONGO_READING_ERROR";
})(SystemErrorCode = exports.SystemErrorCode || (exports.SystemErrorCode = {}));
var QuickTagImportFileType;
(function (QuickTagImportFileType) {
    QuickTagImportFileType["CSV"] = "CSV";
    QuickTagImportFileType["XLSX"] = "XLSX";
    QuickTagImportFileType["SPSS"] = "SPSS";
})(QuickTagImportFileType = exports.QuickTagImportFileType || (exports.QuickTagImportFileType = {}));
var QuickTagMimeType;
(function (QuickTagMimeType) {
    QuickTagMimeType["CSV"] = "text/csv";
    QuickTagMimeType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    QuickTagMimeType["SPSS"] = "application/x-spss-sav";
    QuickTagMimeType["SPSS_BUFFER"] = "application/octet-stream";
})(QuickTagMimeType = exports.QuickTagMimeType || (exports.QuickTagMimeType = {}));
exports.QuickTagMimeTypeFileTypeMap = (_c = {},
    _c[QuickTagMimeType.CSV] = QuickTagImportFileType.CSV,
    _c[QuickTagMimeType.XLSX] = QuickTagImportFileType.XLSX,
    _c[QuickTagMimeType.SPSS] = QuickTagImportFileType.SPSS,
    _c[QuickTagMimeType.SPSS_BUFFER] = QuickTagImportFileType.SPSS,
    _c);
var QUICKTAG_TYPES;
(function (QUICKTAG_TYPES) {
    QUICKTAG_TYPES["PACKAGE"] = "package";
    QUICKTAG_TYPES["FILE"] = "file";
})(QUICKTAG_TYPES = exports.QUICKTAG_TYPES || (exports.QUICKTAG_TYPES = {}));
var SecurityMode;
(function (SecurityMode) {
    SecurityMode["LowSecurity"] = "0";
    SecurityMode["FullSecurity"] = "1";
})(SecurityMode = exports.SecurityMode || (exports.SecurityMode = {}));
var API_VALIDATION_TYPES;
(function (API_VALIDATION_TYPES) {
    API_VALIDATION_TYPES["SECRET_KEY"] = "secret-key";
    API_VALIDATION_TYPES["AUTH_TOKEN"] = "authorization";
})(API_VALIDATION_TYPES = exports.API_VALIDATION_TYPES || (exports.API_VALIDATION_TYPES = {}));
var WEB_SOCKET_CONNECTION_TYPES;
(function (WEB_SOCKET_CONNECTION_TYPES) {
    WEB_SOCKET_CONNECTION_TYPES[WEB_SOCKET_CONNECTION_TYPES["CONNETING"] = 0] = "CONNETING";
    WEB_SOCKET_CONNECTION_TYPES[WEB_SOCKET_CONNECTION_TYPES["OPEN"] = 1] = "OPEN";
    WEB_SOCKET_CONNECTION_TYPES[WEB_SOCKET_CONNECTION_TYPES["CLOSING"] = 2] = "CLOSING";
    WEB_SOCKET_CONNECTION_TYPES[WEB_SOCKET_CONNECTION_TYPES["CLOSED"] = 3] = "CLOSED";
})(WEB_SOCKET_CONNECTION_TYPES = exports.WEB_SOCKET_CONNECTION_TYPES || (exports.WEB_SOCKET_CONNECTION_TYPES = {}));
var DISCOURSE_PERSONAS;
(function (DISCOURSE_PERSONAS) {
    DISCOURSE_PERSONAS["FORMAL"] = "FORMAL";
    DISCOURSE_PERSONAS["DEFAULT"] = "DEFAULT";
})(DISCOURSE_PERSONAS = exports.DISCOURSE_PERSONAS || (exports.DISCOURSE_PERSONAS = {}));
var OPTION_SIZE;
(function (OPTION_SIZE) {
    OPTION_SIZE["AUTO"] = "AUTO";
    OPTION_SIZE["ICON"] = "IC";
    OPTION_SIZE["SMALL"] = "SM";
    OPTION_SIZE["MEDIUM"] = "MD";
    OPTION_SIZE["LARGE"] = "LG";
    OPTION_SIZE["XL"] = "XL";
    OPTION_SIZE["FULL"] = "FULL";
})(OPTION_SIZE = exports.OPTION_SIZE || (exports.OPTION_SIZE = {}));
var PROJECT_EDIT_STATUS;
(function (PROJECT_EDIT_STATUS) {
    PROJECT_EDIT_STATUS["EDIT_REQUIRED"] = "EDIT_REQUIRED";
    PROJECT_EDIT_STATUS["EDITED"] = "EDITED";
    PROJECT_EDIT_STATUS["EDITING"] = "EDITING";
    PROJECT_EDIT_STATUS["COMPLETED"] = "COMPLETED";
    PROJECT_EDIT_STATUS["FAILED"] = "FAILED";
})(PROJECT_EDIT_STATUS = exports.PROJECT_EDIT_STATUS || (exports.PROJECT_EDIT_STATUS = {}));
var IMAGE_OPTION_SIZING;
(function (IMAGE_OPTION_SIZING) {
    IMAGE_OPTION_SIZING[IMAGE_OPTION_SIZING["SM"] = 80] = "SM";
    IMAGE_OPTION_SIZING[IMAGE_OPTION_SIZING["MD"] = 160] = "MD";
    IMAGE_OPTION_SIZING[IMAGE_OPTION_SIZING["LG"] = 320] = "LG";
    IMAGE_OPTION_SIZING[IMAGE_OPTION_SIZING["XL"] = 500] = "XL";
    IMAGE_OPTION_SIZING[IMAGE_OPTION_SIZING["FULL"] = 1100] = "FULL";
})(IMAGE_OPTION_SIZING = exports.IMAGE_OPTION_SIZING || (exports.IMAGE_OPTION_SIZING = {}));
/**
 * Names (pointers) to callback functions that may be used by bot-server.
 */
var CALLBACK_POINTER_KEYS;
(function (CALLBACK_POINTER_KEYS) {
    CALLBACK_POINTER_KEYS["GENERATE_GUIDEDFANTASY"] = "guidedFantasyStoreQuestions";
    CALLBACK_POINTER_KEYS["LOAD_GUIDEDFANTASY"] = "guidedFantasyLoadQuestions";
})(CALLBACK_POINTER_KEYS = exports.CALLBACK_POINTER_KEYS || (exports.CALLBACK_POINTER_KEYS = {}));
var NPS_CATEGORY;
(function (NPS_CATEGORY) {
    NPS_CATEGORY["DETRACTOR"] = "DETRACTOR";
    NPS_CATEGORY["PASSIVE"] = "PASSIVE";
    NPS_CATEGORY["PROMOTER"] = "PROMOTER";
})(NPS_CATEGORY = exports.NPS_CATEGORY || (exports.NPS_CATEGORY = {}));
exports.TRADE_OFF_TYPES = {
    TEXT: 'textOnly',
    IMAGE: 'imageOnly'
};
//# sourceMappingURL=types.js.map